import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Custom Stimulus action option to detect if the user is inputting text
application.registerActionOption("inputting", ({ event, value }) => {
  if (!(event.target instanceof Element)) return false
  const isInputting = event.target?.closest("input, textarea, lexxy-editor") != null

  // value === true  → :inputting   → allow only when inputting
  // value === false → :!inputting  → allow only when NOT inputting
  return isInputting === value
})

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application
export { application }
